import { config } from '@/config';
import { OTElementId } from '@/constants';
import { useAppBridge } from '@shopify/app-bridge-react';

const useHandleContextualNotEmbedded = () => {
  const hide = (_id?: string) => {};
  const show = (_id?: string) => {};
  const leaveConfirmation = async () => {};
  return {
    hide,
    show,
    leaveConfirmation,
  };
};

const useHandleContextual = () => {
  const shopify = useAppBridge();
  // App Bridge throws "SaveBar with ID <id> not found" if the <SaveBar> element has
  // already unmounted (e.g. hiding on unmount, or after a route change). That
  // rejection is harmless — the bar is already gone — but surfaces as an uncaught
  // promise error in the console, so swallow it.
  const hide = (id: string = OTElementId.SaveBar) => {
    try {
      void Promise.resolve(shopify?.saveBar?.hide(id)).catch(() => {});
    } catch {
      /* save bar already gone */
    }
  };

  const show = (id: string = OTElementId.SaveBar) => {
    try {
      void Promise.resolve(shopify?.saveBar?.show(id)).catch(() => {});
    } catch {
      /* save bar not mounted yet */
    }
  };

  // Returns the promise so callers can `await` the merchant's confirmation
  // before navigating / switching views (used by the email template header).
  const leaveConfirmation = () => shopify?.saveBar?.leaveConfirmation();

  return {
    hide,
    show,
    leaveConfirmation,
  };
};

export default config.embedded === '1' ? useHandleContextual : useHandleContextualNotEmbedded;
